// extracted by mini-css-extract-plugin
export default {"page":"Schoolrooms_page__qkaBE","container":"Schoolrooms_container__j+KqU","header":"Schoolrooms_header__QlkqB","bar":"Schoolrooms_bar__Ka-7i","table":"Schoolrooms_table__4jFuM"};